const iosContainer = document.querySelector('.hero__asset-container--mobile-ios');
const androidContainer = document.querySelector('.hero__asset-container--mobile-android');
const homepageHero = document.querySelector('.homepage-hero__section');
const desktopVideo = document.querySelector('.homepage-hero__video');

const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
        return 'Android';
    }
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
    }

    return 'other';
};

if (iosContainer && androidContainer && homepageHero) {
    const currentOs = getMobileOperatingSystem();
    const canPlayWebM = desktopVideo.canPlayType('video/webm; codecs="vp8, vorbis"');

    // for Android, we will hide the visible-by-default Vimeo video and instead display the <div> containting the transparent .webm
    if (currentOs === 'Android') {
        iosContainer.style.display = 'none';
        androidContainer.style.display = 'flex';
    } else if (!canPlayWebM && currentOs !== 'iOS') {
        // This conditional is going to check if .webm can be played and if it is NOT iOS (i.e., desktop Safari).
        // We'll look at the data-attribute value (as set in the CMS) and change the background of the 
        // containing <div> to match.
        const safariBgColor = homepageHero.getAttribute('data-safari');
        homepageHero.style.backgroundColor = safariBgColor;
    }
}
